import { useEffect, useState } from "react";
import LoadingScreen from "../../components/LoadingScreen";
import { getData } from "../../apis";
import { API } from "../../apis/config";
import { useDispatch } from "react-redux";
import { Notices } from "../../components/Notices";
import { Notice } from "../../interfaces/Notice";
// import parkingMap from "../../assets/images/parking_area.png";

export default function Home() {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  const [noticeList, setNoticeList] = useState<Notice[]>([]);

  useEffect(() => {
    const data = async () => {
      var response = await getData<Notice[]>(API.OPENING_WAREHOUSE.NOTICES);
      setNoticeList(response.result);
    };
    data().finally(() => {
      setIsLoading(false);
    });
  }, [dispatch]);

  return (
    <div>
      {isLoading ? (
        <LoadingScreen />
      ) : (
        <div>
          <div className="font-bold text-xl">[창고개방전 주차 안내]</div>
          <div className="flex justify-center p-1 mt-5">
            <div className="bg-[#99ec72] px-1">초록색</div>
            <div className="font-bold">
              은 건물 앞에 주차가 가능한 공간입니다
            </div>
          </div>

          <div className="flex justify-center p-1">
            <div className="bg-[#f4de7d] px-1">노란색</div>
            <div className="font-bold">
              은 도로 옆으로 주차가 가능한 공간입니다
            </div>
          </div>

          {/* <div className="flex justify-center mt-1">
            <img src={parkingMap} alt="parking_map" className="rounded-lg " />
          </div> */}

          <Notices noticeList={noticeList} />
        </div>
      )}
    </div>
  );
}
